import { reportError } from '../sentry';

const parseLocalStorageItem = (key) => {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  } catch (error) {
    reportError(error, 'parseLocalStorageItem', { extra: { key } });
    return null;
  }
};


const extractNameFromUser = (user) => {
  if (user.first_name && user.last_name) {
    return {
      firstName: user.first_name,
      lastName: user.last_name
    };
  }
  
  if (user.name) {
    const nameParts = user.name.split(' ');
    return {
      firstName: nameParts[0] || '',
      lastName: nameParts.slice(1).join(' ') || ''
    };
  }
  
  return null;
};


export const getUserName = () => {
  const user = parseLocalStorageItem('user');
  if (user) {
    const name = extractNameFromUser(user);
    if (name) return name;
  }
  
  const creator = parseLocalStorageItem('creator');
  if (creator?.user_data) {
    const name = extractNameFromUser(creator.user_data);
    if (name) return name;
  }
  
  return { firstName: '', lastName: '' };
}; 


export const getUserEmail = () => {
  const userEmail = localStorage.getItem('userEmail');
  if (userEmail) return userEmail;
  
  const user = parseLocalStorageItem('user');
  if (user?.email) return user.email;
  
  const creator = parseLocalStorageItem('creator');
  if (creator?.user_data?.email) return creator.user_data.email;
  
  return '';
};